import { Checkbox, Label } from '~/components/ui'

type MapFeaturedFilterProps = {
  featured?: 'true'
  updateFilter: (key: string, value: any) => void
}

export default function MapFeaturedFilter({
  featured,
  updateFilter,
}: MapFeaturedFilterProps) {
  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-2 text-sm font-normal">
        <Checkbox
          checked={featured === 'true'}
          onCheckedChange={(value: boolean) => {
            updateFilter('featured', value ? 'true' : undefined)
          }}
        />
        <span>Featured listings only</span>
      </Label>
    </div>
  )
}
